import { generatePath } from 'react-router-dom';

import { ValueOf } from './util.model';

const REPORTING_ROUTES = {
  AI_FINDINGS: 'ai-findings',
  COMPARISONS: 'comparisons',
  CWF_DOCUMENT: 'cwf/:typeId',
  CWF_DOCUMENT_CARE_PLAN: '/document/cwf/careplan/:carePlanId/:careActivityId/:typeId',
  DOCUMENT: '/document/:studyId',
  FINAL_IMPRESSIONS: 'final-impressions',
  KEY_IMAGES: 'key-images',
  MHS_DOCUMENT: 'mhs',
  ORGAN: 'organ/:organ',
  PREVIEW: 'preview',
  QUALITY_REVIEW: 'quality-review',
  QUALITY_REVIEW_DOCUMENT: 'quality-review/:itemId',
  RADIOLOGY_REPORT_DOCUMENT: 'radiology-report',
  REASON_FOR_SCAN: 'reason-for-scan',
  REPORTING: '/reporting/:studyId',
} as const;

export const APP_ROUTES = {
  NOT_FOUND: '/404',
  ...REPORTING_ROUTES,
} as const;

export type AppRouteKey = keyof typeof APP_ROUTES;

export type AppRoute = ValueOf<typeof APP_ROUTES>;

export type BaseRoutePathParam = Parameters<typeof generatePath<AppRoute>>[1];

export type RoutePathParam = BaseRoutePathParam & {
  careActivityId?: null | string;
  carePlanId?: null | string;
};

export type ParentRoute = 'DOCUMENT' | 'REPORTING';

export interface RouteConfig {
  parent?: ParentRoute;
}

export type PathConfig = {
  params?: Partial<RoutePathParam>;
  query?: string;
};

export const DEFAULT_PATH_PARAMS: NonNullable<RoutePathParam> = {
  careActivityId: null,
  carePlanId: null,
  itemId: null,
  organ: null,
  studyId: null,
  typeId: null,
};

export const ROUTES: { [key in AppRouteKey]: RouteConfig } = {
  AI_FINDINGS: {
    parent: 'REPORTING',
  },
  COMPARISONS: {
    parent: 'REPORTING',
  },
  CWF_DOCUMENT: {
    parent: 'DOCUMENT',
  },
  CWF_DOCUMENT_CARE_PLAN: {},
  DOCUMENT: {},
  FINAL_IMPRESSIONS: {
    parent: 'REPORTING',
  },
  KEY_IMAGES: {
    parent: 'REPORTING',
  },
  MHS_DOCUMENT: {
    parent: 'DOCUMENT',
  },
  NOT_FOUND: {},
  ORGAN: { parent: 'REPORTING' },
  PREVIEW: {
    parent: 'REPORTING',
  },
  QUALITY_REVIEW: {
    parent: 'REPORTING',
  },
  QUALITY_REVIEW_DOCUMENT: {
    parent: 'DOCUMENT',
  },
  RADIOLOGY_REPORT_DOCUMENT: {
    parent: 'DOCUMENT',
  },
  REASON_FOR_SCAN: {
    parent: 'REPORTING',
  },
  REPORTING: {},
};
